<template>
    <div class="dsTable w-full">
        <div class="dsTable__header">
            <div class="flex justify-between items-center">
                <div class="flex">
                    <slot name="header"></slot>
                    <vs-dropdown v-if="paginate" vs-trigger-click class="cursor-pointer mr-4 items-per-page-handler">
                        <div
                            class="p-4 border border-solid flex d-theme-border-grey-light rounded-full flex-grow d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2 whitespace-no-wrap">
                                    {{ (pagex - 1) * limit + 1 }} - {{
                                        (pagex - 1) * limit + limit
                                    }} of {{ total ? total : dataList.length }}
                                </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item v-for="(item, index) of viewItems" :key="index"
                                              @click="changeLimit(item)">
                                <span>{{ item }}</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
                <div class="flex items-center">
                    <vs-input v-if="search" icon-pack="feather" icon="icon-search" :placeholder="$t('global.Search')"
                              v-model="searchInput" class="search is-label-placeholder w-full mr-4"/>
                    <vs-pagination
                        v-if="paginate"
                        ref="pagination"
                        :class="{'loader': paginationLoader}"
                        :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
                        :total="getTotalPages" v-model="pagex"></vs-pagination>
                </div>
            </div>
        </div>
        <div class="dsTable__content">
            <table ref="table" class="w-full">
                <thead ref="thead">
                <tr>
                    <th style="width: 20px;" v-if="expand"></th>
                    <th class="p-2"
                        v-for="(head, index) of heads"
                        :key="index"
                        v-if="head.display && isPermission(head.can)"
                        @click="sortItem(head.sortKey)"
                    >
                        <div class="items-center flex">
                            <div class="uppercase select-none w-full" :class="{'text-center': head.center}">
                                {{ head.translate === 'none' ? head.name : $t(head.name) }}
                            </div>
                            <div
                                v-if="head.sortKey && currentSort[head.sortKey]"
                                class="ml-2"
                                :class="{activeExpand: currentSort[head.sortKey] === 'desc'}"
                            >
                                <vs-icon v-if="head.sortKey" icon-pack="feather" icon="icon-chevron-down"></vs-icon>
                            </div>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody ref="tbody">
                <slot v-if="notSlots"></slot>
                </tbody>
            </table>
        </div>
        <div class="w-full text-center not-data-table vs-table--not-data">
            <slot name="footer"></slot>
        </div>
        <div>
            <vs-pagination
                :class="{'loader': paginationLoader}"
                v-if="paginate"
                ref="pagination2"
                :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
                :total="getTotalPages"
                v-model="pagex"
            ></vs-pagination>
        </div>
    </div>
</template>

<script>
import {fixHindusPagination, checkPermission} from '@/utils/mixins'

export default {
    mixins: [fixHindusPagination, checkPermission],
    props: {
        notSlots: {
            type: Boolean,
            default: false
        },
        rowspan: {
            type: Array
        },
        toDataText: {
            type: String,
        },
        heads: {
            type: Array,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        expand: {
            type: Boolean,
            default: false
        },
        spacer: {
            type: Boolean,
            default: false
        },
        accordion: {
            type: Boolean,
            default: false
        },
        search: {
            type: Boolean,
            default: false
        },
        maxItems: {
            type: Number
        },
        viewItems: {
            type: Array,
            default: () => {
                return [10, 15, 20]
            }
        },
        total: {
            type: Number
        },
        ssr: {
            type: Boolean,
            default: false
        },
        paginate: {
            type: Boolean,
            default: true
        },
        page: {
            type: Number,
            default: 1
        },
        can: {
            type: String
        },
        searchProps: {
            type: Array,
            default: () => {
                return []
            }
        }
    },

    data() {
        return {
            dataList: [],
            currentSort: {},
            currentSortActive: null,
            expandx: {},
            pagex: 1,
            limit: 10,
            searchInput: '',
            refPaginationPagesLength: 0,
            paginationLoader: false
        }
    },

    computed: {
        tableData() {
            if(this.ssr) {
                return this.dataList
            } else {
                const index = (this.pagex - 1) * this.limit
                return this.dataList.slice(index, index + this.limit)
            }
        },

        getTotalPages() {
            return Math.ceil((this.total ? this.total : this.dataList.length) / this.limit)
        }
    },

    watch: {
        data(value) {
            if(this.ssr) {
                this.paginationLoader = false
            }

            this.dataList = value

            // this.pagex = value.length ? 1 : 0

            if (this.expand) {
                this.refresh()
            }
        },

        page(page) {
            this.pagex = page
        },

        pagex() {
            if(this.expand) {
                this.closeExpands()
            }

            if(this.ssr) {
                this.$emit('page', this.pagex)
                this.paginationLoader = true
            }
        },

        limit() {
            this.pagex = 1

            if(this.ssr) {
                this.$emit('limit', this.limit)
            }
        },

        searchInput(value) {
            if(!this.ssr) {
                if(this.expand) {
                    this.closeExpands()
                }
                this.currentSort = {}
                this.pagex = 1
                this.dataList = this.searchInData(value.toLowerCase())
            }
        }
    },

    methods: {
        refresh() {
            const axp = {...this.expandx}
            this.closeExpands()
            this.$nextTick(() => {
                this.expandx = axp
            })
        },

        searchInData(data) {
            if(this.searchInput) {
                let search = []
                const arr = []

                if(this.searchProps.length) {
                    search = this.searchProps
                } else {
                    search = this.heads.map(item => item.sortKey).filter(item => item)
                }

                search_loop:
                    for(const element of this.data) {
                        for(const item of search) {
                            if(typeof item === 'string') {
                                if(element[item]) {
                                    const search = (element[item].toString().toLowerCase()).search(data)
                                    if(search !== -1) {
                                        arr.push(element)
                                        continue search_loop
                                    }
                                }
                            }

                            if(Object.isObject(item)) {
                                if(element[item.name] && Array.isArray(element[item.name])) {
                                    for(const field of element[item.name]) {
                                        if(Array.isArray(item.find)) {
                                            for(const key of item.find) {
                                                if(field[key]) {
                                                    const search = (field[key].toString().toLowerCase()).search(data)
                                                    if(search !== -1) {
                                                        arr.push(element)
                                                        continue search_loop
                                                    }
                                                }
                                            }
                                        }
                                    }
                                } else if(element[item.name] && Object.isObject(element[item.name])) {
                                    if(Array.isArray(item.find)) {
                                        for(const key of item.find) {
                                            const search = element[item.name][key].toString().toLowerCase() === data.toString().toLowerCase()
                                            if(search) {
                                                arr.push(element)
                                                continue search_loop
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                return arr
            } else {
                return this.data
            }
        },

        changeLimit(element) {
            this.limit = element
        },

        changeExpand(index) {
            if(this.expand) {
                if(this.accordion && !this.expandx[index])
                    Object.keys(this.expandx).map(key => delete this.expandx[key])
                this.$set(this.expandx, index, !this.expandx[index])
            }
        },

        closeExpands() {
            this.expandx = {}
        },

        sortItem(key) {
            if (key) {
                if(this.expand) {
                    this.closeExpands()
                }

                // if (!this.currentSort[key]) this.$set(this.currentSort, key, '')

                if(!this.currentSort[key]) {
                    this.currentSort = {[key]: 'desc'}
                } else if(this.currentSort[key] === 'desc') {
                    this.currentSort = {[key]: 'asc'}
                } else {
                    this.currentSort = {[key]: null}
                }

                if(this.ssr) {
                    Object.keys(this.currentSort).map(key => {
                        if (!this.currentSort[key]) delete this.currentSort[key]
                    })

                    this.$emit('sort', this.currentSort)
                } else {
                    this.dataList = this.sort(this.data, this.currentSort)
                }
            }
        },

        sort(data, action) {
            function compare(a, b) {
                if(a[action.name] < b[action.name])
                    return action.type === 'desc' ? 1 : -1
                if(a[action.name] > b[action.name])
                    return action.type === 'desc' ? -1 : 1
                return 0
            }

            return action.type !== null ? [...data].sort(compare) : [...data]
        }
    },

    mounted() {
        if(this.maxItems) {
            this.limit = this.maxItems
        }

        this.dataList = this.data

        this.$watch(
            () => {
                if(this.$refs.pagination) {
                    return this.$refs.pagination.pages
                }
            },
            value => {
                if(value) {
                    this.$set(this, 'refPaginationPagesLength', value[value.length - 1])

                    Object.assign(this.$refs.pagination, {getPages: this.getPages(this.$refs.pagination)})
                    Object.assign(this.$refs.pagination2, {getPages: this.getPages(this.$refs.pagination2)})
                }
            }
        )
    }
}
</script>

<style lang="scss">
.dsTable {
    overflow: hidden;

    &__content {
        overflow-x: auto;
    }

    table {
        border-collapse: collapse;
        //border-spacing: 0px 15px;
    }

    .td {
        background-color: white;

        &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
        }

        &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
        }
    }

    .spacertd {
        border-radius: 0 !important;
    }

    .spacertr {
        &:nth-child(2n) {
            .spacertd {
                background-color: transparent;
            }
        }
    }

    .activeExpand {
        transform: rotate(180deg);
        transition: .25s ease;
    }

    .chevron-down {
        transition: .25s ease;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .vs-pagination--ul {
        li {
            font-size: .8rem;
            width: 30px;
            height: 30px;
        }
    }

    .search input {
        border-radius: 50px;
    }

    .vs-inputx {
        &:focus {
            border: 1px solid rgba(0, 0, 0, 0.2) !important;
            box-shadow: none !important;
        }
    }

    .loader {
        button {
            pointer-events: none;
        }

        ul {
            li {
                pointer-events: none;
            }
        }
    }
}
</style>
